import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Select } from 'antd';
import { Dropdown } from '../../shared'
import CareersButton from '../../../assets/img/careers2.png'
import {ReactComponent as LogoSvg} from '../../../assets/images/logo.svg';
import {ReactComponent as TgSvg} from '../../../assets/images/tg.svg';
import {ReactComponent as VkSvg} from '../../../assets/images/vk.svg';
import { ReactComponent as MenuButtonSvg } from '../../../assets/icons/buttonMenu.svg';

import { addressesArray } from '../../../utils/helpers/constants';
import { RestaurantContext } from '../../../providers/restaurant';

import { removeParentheses } from "../../../utils/helpers/functions"

import localStyle from './styles.module.scss';
import useResizeWindows from '../../../utils/hooks/useResizeWindow';
import { SAVED_REST_ID_KEY } from '../../../App';


const { Option } = Select;

function scrollToFooter(e, width) {
  e.preventDefault()
  const elem = document.querySelector('#places')
      , r = elem.getBoundingClientRect()
  let adjustment = -40
  if (width > 1440) {
    adjustment = -120
  } else if (width > 1024) {
    
  } else if (width > 884) {
    adjustment = -60
  } else if (width >= 448) {
    adjustment = -100
  } else if (width < 448) {
    adjustment = -80
  }
  window.scrollTo({
    top: window.scrollY + r.top + adjustment,
    behavior: 'smooth',
  })
}

export const HeaderInner = ({type}) => {
  let {
    places, current, setCurrent,
  } = useContext(RestaurantContext)

  const width = useResizeWindows()

  function labelValue(p) {
    return p?.city + '-' + p?.id
  }
  // const [current, setCurrent] = useState('mail');

  const headerMenuItems = [
    {
      label: 'Меню',
      key: 'menu',
      link: 'menu',
    },
    {
      label: 'Бронирование',
      key: 'reservation',
      link: 'reservation',
    },
    {
      label: 'События',
      key: 'events-header',
      // link: 'events',
      children: [
        {
          label: 'Афиши',
          key: 'events',
          link: 'events',
        },
        {
          label: 'Караоке',
          key: 'karaoke',
          link: 'karaoke',
        },
        {
          label: 'Кухня',
          key: 'kitchen',
          link: 'kitchen',
        },
        {
          label: 'Танцы',
          key: 'dance',
          link: 'dance',
        },
        {
          label: 'Бар',
          key: 'bar',
          link: 'bar',
        },
      ],
    },
    {
      label: 'Карьера',
      key: 'job',
      link: 'job',
    },
    {
      label: 'Франчайзи',
      key: 'partner',
      link: 'partner',
    },
    {
      label: 'Контакты',
      key: 'contacts',
      link: 'contacts'
    },
  ];
  const footerMenuItems = [
    {
      label: 'Меню',
      key: 'menu',
      link: 'menu',
    },
    {
      label: 'Бронирование',
      key: 'reservation',
      link: 'reservation',
    },
    {
      label: 'События',
      key: 'events',
      link: 'events',
    },
    {
      label: 'Карьера',
      key: 'job',
      link: 'job',
    },
    {
      label: 'Франчайзи',
      key: 'partner',
      link: 'partner',
    },
  ];
  const menuItems = type === 'header' ? headerMenuItems : footerMenuItems

  const getOptions2 = (array, current) => {
    return (array.map(item => (
      <Option key={labelValue(item)} value={labelValue(item)} label={labelValue(item)}>
        <div className={localStyle['header-custom-option']}>
          <span>{item?.city}</span>
          <span>{item?.is_coming_soon ? 'Скоро открытие' : item?.address}</span>
        </div>
      </Option>
    )))
  }

  const [showingMobileMenu, setShowingMobileMenu] = useState(false)

  const hideMobileMenu = useCallback(e => {
    setShowingMobileMenu(false)
  }, [])
      , onMobileNav = useCallback(e => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    })
    hideMobileMenu(e)
  }, [hideMobileMenu])

  const [mobileCityPicker, setMobileCityPicker] = useState({showing: false})

  const headerMenu_ = useMemo(() => menuItems.map(menuItem => {
    switch (menuItem.key) {
      case 'contacts':
        return <a className={localStyle['header__navLink'] + ' ' + localStyle['link']} key="contacts" href="#places"
          onClick={e => scrollToFooter(e, width)}
        >{menuItem.label}</a>
      case 'events-header':
        return <Dropdown>
          <NavLink
            className={localStyle['header__navLink'] + ' ' + localStyle['link']}
            key={menuItem.key}
          >События</NavLink>
          <>{menuItem.children.map(
            mi => <NavLink
              key={mi.key}
              to={`/${mi.link}`}
              className={({ isActive }) => (isActive && mi.link !== 'contacts' ? (localStyle['header__navLinkActive'] + ' ' + localStyle['link']) : (localStyle['header__navLink'] + ' ' + localStyle['link']))}
              onClickCapture={e => {
                window.scrollTo({
                  top: 0,
                  left: 0,
                  behavior: "smooth",
                })
              }}
            >{mi.label}</NavLink>
          )}</>
        </Dropdown>
      case 'job':
        return <NavLink
          key={menuItem.key}
          to={`/${menuItem.link}`}
          onClickCapture={e => {
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "smooth",
            })
          }}
        ><img className={localStyle['careers-button']} src={CareersButton} alt='Карьера' /></NavLink>
      default:
        return <NavLink
          key={menuItem.key}
          to={`/${menuItem.link}`}
          className={({ isActive }) => (isActive && menuItem.link !== 'contacts' ? (localStyle['header__navLinkActive'] + ' ' + localStyle['link']) : (localStyle['header__navLink'] + ' ' + localStyle['link']))}
          onClickCapture={e => {
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "smooth",
            })
          }}
        >{menuItem.label}</NavLink>
    }
  }), [menuItems, width])
  
  useEffect(() => {
    if (showingMobileMenu)
      document.querySelector('dialog[class*="menu-mobile"]')?.showModal()
    else
      document.querySelector('dialog[class*="menu-mobile"]')?.close()
  }, [showingMobileMenu])

  return (<>
    <div className={localStyle['inner']} data-inner={type === "footer" ? "true" : "false"}>
        <div className={localStyle['other-left']}>
          <Link to="/" onClick={e => {
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "smooth",
            })
            setShowingMobileMenu(false)
          }}>
            <div className={localStyle['logo']}>
              <LogoSvg />
            </div>
          </Link>

          {type === 'header' ? (
            <div className={localStyle['header-select-wrapper']}>
              <Select
                placeholder='Город'
                value={places && places.length > 0 && labelValue(places[current])}

                onChange={(value, option) => {
                  const idx = places.findIndex(i => labelValue(i) === value)
                  setCurrent(idx)
                  localStorage.setItem(SAVED_REST_ID_KEY, places[idx].id)
                }}
                dropdownStyle={{
                  height: 'min-content',
                  maxHeight: 'unset',
                  width: '20%',
                }}
              >
                {getOptions2((places && places.length > 0 && places) || addressesArray)}
              </Select>
              <div className={localStyle['mob']} onClick={e => {
                  setMobileCityPicker({
                    showing: !mobileCityPicker.showing,
                  })
              }}>
                <span>{places?.[current]?.city}</span>
                <svg viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M21.5003 3.5835C13.5842 3.5835 7.16699 10.7548 7.16699 18.8127C7.16699 26.8074 11.7417 35.4974 18.8792 38.8335C20.5431 39.6113 22.4575 39.6113 24.1214 38.8335C31.259 35.4974 35.8337 26.8074 35.8337 18.8127C35.8337 10.7548 29.4164 3.5835 21.5003 3.5835ZM21.5003 21.5002C23.4793 21.5002 25.0837 19.8958 25.0837 17.9168C25.0837 15.9378 23.4793 14.3335 21.5003 14.3335C19.5213 14.3335 17.917 15.9378 17.917 17.9168C17.917 19.8958 19.5213 21.5002 21.5003 21.5002Z" fill="#41B64D"/>
                </svg>
              </div>
              {
                mobileCityPicker.showing && <div className={localStyle['mobile-city-picker-dropdown']}>
                  {
                    places?.map(
                      (p, idx) => {
                        return <>
                        {idx !== 0 && <hr/>}
                        <div
                          className={localStyle['header-custom-option'] + (current === idx ? ' ' + localStyle['active'] : '')}
                          onClick={e => {
                            setCurrent(idx)
                            localStorage.setItem(SAVED_REST_ID_KEY, places[idx].id)
                            setMobileCityPicker({
                              showing: false,
                            })
                          }}
                        >
                          <span>{p?.city}</span>
                          <span>{p?.is_coming_soon ? 'Скоро открытие' : p?.address}</span>
                        </div></>
                      }
                    )
                  }
                </div>
              }
            </div>
          ) : null}
        </div>
        {
          type === 'header' ? (<div className={localStyle['menu-links']}>
            {headerMenu_}
          </div>) : null
        }

        {
          // eslint-disable-next-line no-mixed-operators
          (width > 650 && type === 'header' || width <= 650 && type === 'footer') && (
            <div className={localStyle['other-right']}>
            {type === 'header' && <div className={localStyle['phone']}>{removeParentheses(places?.[current]?.phone) || 'тлф. неизвестен'}</div>}
            <div className={localStyle['socials']}>
              <div onClick={e => window.open(places?.[current]?.city__tg, "_blank").focus()} className={localStyle['social']}><TgSvg /></div>
              <div onClick={e => window.open(places?.[current]?.city__vk, "_blank").focus()} className={localStyle['social']}><VkSvg /></div>
            </div>
          </div>
          )
        }

      { type === 'header' ? 
        <div className={localStyle['menuButton']} onClick={
          () => {
            setShowingMobileMenu(true)
          }
        }><MenuButtonSvg /></div>
        : <></>
      }
    </div>
    {
      type === "header" && showingMobileMenu && (
        <dialog className={localStyle["menu-mobile"]}>
          <div className={localStyle["head"]}>
              <Link to="/" onClick={hideMobileMenu}>
                <div className={localStyle["logo"]}>
                  <svg viewBox="0 0 83 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M0.0100606 5.55045L0 21.3585L6.02139 21.4427L6.06641 6.10997C8.68198 5.92157 10.8341 8.19189 10.7866 10.9645C10.7133 15.2411 7.73132 15.7071 6.64647 16.0522L6.65335 21.4286C11.3598 21.3018 13.4305 19.1581 15.1412 16.6708C17.1062 13.814 17.5325 9.73189 15.759 6.33563C14.0669 3.09525 9.99776 0.100478 5.5828 0.659756C4.46356 1.63213 2.97311 2.94506 1.74618 4.02909C1.03527 4.64125 0.660229 4.97922 0.0100921 5.55045H0.0100606Z" fill="#131313"/>
                      <path fillRule="evenodd" clipRule="evenodd" d="M25.4024 0.479433C12.6587 2.75167 15.2889 24.4697 29.756 21.5042C41.6709 19.0619 39.7492 -2.07866 25.4024 0.479433ZM29.1664 15.8689C33.5355 13.6699 31.123 3.50445 25.4892 6.09513C25.2694 6.22289 23.988 6.78946 23.5199 8.92248C23.2578 10.1053 23.2875 11.8567 23.5464 13.0159C24.0867 15.434 26.4977 17.212 29.1664 15.8689Z" fill="#131313"/>
                      <path fillRule="evenodd" clipRule="evenodd" d="M25.4897 6.09559C31.1236 3.50491 33.536 13.6703 29.1669 15.8693C26.4981 17.2125 24.087 15.4344 23.5469 13.0163C23.288 11.8571 23.2583 10.1056 23.5203 8.92289C23.9884 6.78987 25.2698 6.22335 25.4897 6.09553V6.09559ZM31.7155 13.655C34.3743 5.95514 25.0038 1.98411 23.1046 8.14273C20.6742 16.9805 29.5666 19.7986 31.7155 13.6551V13.655Z" fill="#131313"/>
                      <path d="M52.1824 6.06681H45.6221C45.0967 6.06681 44.7716 6.37213 44.6309 6.7598C44.5163 7.08604 44.5153 7.44116 44.6281 7.76804C44.6281 8.08393 45.1344 8.41167 45.4584 8.4092C46.0006 8.4092 46.5843 8.42875 47.1255 8.4756C47.4169 8.50033 47.7065 8.54127 47.9932 8.59823C48.3244 8.66097 50.3082 9.23001 51.6512 10.9676C52.3849 11.9166 52.9313 13.2114 52.9227 14.9568C52.9133 16.9241 52.2071 18.3701 51.2561 19.3986C49.8171 20.955 47.8051 21.5489 46.8067 21.5489H38.5607L38.5535 18.8251C38.5598 17.917 38.5626 17.0115 38.5498 16.1033H46.0401C46.4107 16.1205 46.6613 15.8912 46.8267 15.5798C46.9069 15.4289 46.9595 15.2652 46.9822 15.0961C47.0055 14.9316 46.9942 14.7641 46.9491 14.6041C46.8471 14.2581 46.5494 13.9602 45.9733 13.8633C45.5679 13.8215 45.1865 13.7913 44.7977 13.7608C44.4738 13.7352 44.1446 13.7092 43.7157 13.6674C42.5354 13.511 41.1104 12.6152 40.3006 11.7779C39.5177 10.9685 38.9007 9.89787 38.7635 8.55704C38.6521 7.875 38.6926 6.57102 38.8447 5.87685C38.9908 5.20929 39.2458 4.70431 39.5942 4.08883C39.9711 3.42077 40.7919 2.48256 41.7892 1.7674C42.5615 1.21381 43.4448 0.788803 44.3218 0.714147C44.3218 0.497436 56.428 0.693817 57.9588 0.728909L52.1823 6.06681H52.1824Z" fill="#131313"/>
                      <path d="M56.3818 5.4458L61.8587 0.514294L62.298 0.118652V8.62791L71.0417 0.861614H79.1753L69.0115 10.6878L73.0766 14.507V22.1947L64.5129 14.5575L62.2979 16.6266V21.5364H56.3818V5.4458Z" fill="#131313"/>
                      <path d="M77.084 21.5103V5.32718L82.9998 0V21.5103H77.084Z" fill="#131313"/>
                      <path d="M22.8292 23.9904V23.6472H21.1189C20.6859 23.6472 20.2088 23.8297 19.9666 24.2387C19.7831 24.5452 19.7686 24.9031 19.7686 25.1514V27.1812C19.7686 27.4877 19.7832 27.8238 19.9741 28.1523C20.3337 28.7656 20.9869 28.8021 21.4053 28.8021C21.8383 28.8021 22.4621 28.7437 22.8071 28.1888C23.0347 27.8238 23.0788 27.2834 23.0788 26.7869C23.0788 26.3707 23.0568 25.867 22.8219 25.5018C22.5138 25.0126 21.9411 24.8885 21.5153 24.8885H20.1501C20.1575 24.6549 20.2529 24.4066 20.4144 24.246C20.5832 24.078 20.8621 23.9904 21.141 23.9904H22.8292ZM20.1502 25.2317H21.5375C21.9631 25.2317 22.22 25.363 22.3669 25.5164C22.6677 25.823 22.6677 26.3123 22.6677 26.7358C22.6677 27.1885 22.6457 27.8091 22.3817 28.1231C22.1176 28.4371 21.6549 28.459 21.3907 28.459C21.0311 28.459 20.5907 28.3933 20.3485 28.0355C20.2091 27.8385 20.1504 27.539 20.1504 27.2615L20.1502 25.2317ZM23.8129 24.8885V25.2317H25.6993C25.7764 25.23 25.8529 25.2447 25.9238 25.2749C25.9947 25.3051 26.0583 25.3501 26.1102 25.4069C26.2057 25.5237 26.2571 25.7427 26.2571 25.8668V26.4437H24.5687C24.3486 26.4437 24.0549 26.4728 23.8421 26.6481C23.5632 26.8817 23.5192 27.2468 23.5192 27.5608C23.5192 27.7945 23.5412 28.3202 23.8642 28.583C24.077 28.751 24.3486 28.7582 24.5688 28.7582H26.0661C26.1981 28.7582 26.389 28.7582 26.5065 28.6487C26.6313 28.5319 26.6385 28.3493 26.6385 28.2471V25.9325C26.6385 25.6988 26.6092 25.3775 26.4036 25.1585C26.2496 24.9906 25.9853 24.8884 25.7211 24.8884L23.8129 24.8885ZM26.2571 26.787V28.24C26.2571 28.2911 26.2571 28.3275 26.2057 28.3713C26.1543 28.4151 26.0809 28.4151 26.0369 28.4151H24.4661C24.3941 28.4158 24.3229 28.4012 24.257 28.3722C24.1912 28.3433 24.1323 28.3006 24.0844 28.2472C23.9524 28.0865 23.9304 27.8091 23.9304 27.5754C23.9304 27.3053 23.9598 27.1008 24.0551 26.9767C24.1139 26.8964 24.2532 26.7869 24.4809 26.7869L26.2571 26.787ZM27.7544 28.7584H28.8554C29.4865 28.7584 29.9269 28.6416 30.2352 28.1816C30.5141 27.7581 30.5435 27.2543 30.5435 26.7651C30.5435 26.3051 30.5288 25.7502 30.1325 25.334C29.7508 24.9251 29.2296 24.8885 28.9728 24.8885H27.9892C27.8792 24.8885 27.703 24.8959 27.5563 25.0053C27.499 25.0476 27.4526 25.1027 27.4207 25.1661C27.3888 25.2295 27.3724 25.2995 27.3727 25.3705V29.9997H27.7544L27.7544 28.7584ZM27.7544 28.4152V25.4215C27.752 25.3954 27.756 25.3691 27.7663 25.3449C27.7765 25.3207 27.7926 25.2994 27.8131 25.2828C27.8469 25.2555 27.8874 25.2379 27.9304 25.2317H29.0535C29.4058 25.2317 29.8095 25.3849 29.993 25.7939C30.081 25.9909 30.1325 26.2831 30.1325 26.8161C30.1325 27.3199 30.0885 27.7069 29.9124 27.9771C29.7143 28.2764 29.3619 28.4152 29.0096 28.4152H27.7544ZM31.1307 26.9914H33.3326V26.5679H31.1307V26.9914ZM34.4483 28.7585H35.5492C36.1805 28.7585 36.6208 28.6417 36.9291 28.1817C37.208 27.7582 37.2372 27.2544 37.2372 26.7652C37.2372 26.3052 37.2226 25.7503 36.8262 25.3341C36.4446 24.9252 35.9234 24.8887 35.6666 24.8887H34.683C34.5729 24.8887 34.3969 24.896 34.2499 25.0055C34.1927 25.0478 34.1463 25.1028 34.1144 25.1662C34.0825 25.2297 34.0661 25.2997 34.0665 25.3706V29.9998H34.4482L34.4483 28.7585ZM34.4483 28.4154V25.4216C34.4459 25.3955 34.45 25.3692 34.4602 25.345C34.4704 25.3208 34.4865 25.2995 34.507 25.2829C34.5408 25.2556 34.5813 25.238 34.6243 25.2318H35.7474C36.0997 25.2318 36.5034 25.385 36.6869 25.794C36.7749 25.9911 36.8263 26.2833 36.8263 26.8162C36.8263 27.3201 36.7823 27.707 36.6062 27.9772C36.4082 28.2765 36.0557 28.4154 35.7035 28.4154H34.4483ZM40.9293 28.7585V28.4154H39.0209C38.5071 28.4154 38.2428 28.0575 38.1548 27.7436C38.0961 27.5391 38.0814 27.1813 38.0888 26.955H40.4595C40.5695 26.955 40.7531 26.9403 40.8705 26.8382C41.0245 26.7068 41.032 26.4439 41.032 26.3344C41.032 25.524 40.5622 25.2026 40.4081 25.1077C40.0925 24.9251 39.6888 24.8887 39.4173 24.8887C39.0283 24.8887 38.5511 24.9399 38.1989 25.232C37.707 25.6409 37.6777 26.298 37.6777 26.8383C37.6777 27.4078 37.6924 27.8971 37.9933 28.2841C38.2943 28.6783 38.7053 28.7587 39.0209 28.7587H40.9292L40.9293 28.7585ZM38.0888 26.6118C38.0961 26.2322 38.1182 25.9547 38.2723 25.6991C38.5439 25.2464 38.9622 25.2318 39.3512 25.2318C39.6962 25.2318 40.0778 25.2391 40.3567 25.5676C40.4887 25.7209 40.6208 25.9765 40.6208 26.3563C40.6208 26.4073 40.6282 26.6118 40.4594 26.6118H38.0888ZM44.5257 28.7585V28.4154H43.1605C42.8082 28.4154 42.243 28.3497 42.0155 27.8386C41.9201 27.6194 41.8835 27.1814 41.8835 26.9258C41.8835 26.736 41.9055 26.2322 41.9569 26.0205C42.0743 25.5604 42.4559 25.2318 43.0798 25.2318H44.4376V24.8886H43.1239C42.5147 24.8886 42.1404 25.0931 41.9128 25.3194C41.5017 25.7356 41.4724 26.3489 41.4724 26.8746C41.4724 27.4442 41.5164 27.9042 41.8246 28.2693C42.0522 28.5395 42.4192 28.7586 42.9697 28.7586H44.5257L44.5257 28.7585ZM46.5221 28.7585V25.2317H47.99V24.8885H44.6726V25.2317H46.1404V28.7583L46.5221 28.7585ZM48.1369 26.8017C48.1369 27.6415 48.3717 28.116 48.6213 28.3643C49.047 28.7805 49.7148 28.8023 50.0598 28.8023C50.4048 28.8023 51.0728 28.7804 51.4984 28.3643C51.748 28.116 51.9829 27.6415 51.9829 26.8017C51.9829 26.3709 51.9242 25.6845 51.4984 25.2684C51.1168 24.896 50.5516 24.8449 50.0598 24.8449C49.568 24.8449 49.0029 24.896 48.6213 25.2684C48.1955 25.6844 48.1369 26.3707 48.1369 26.8015V26.8017ZM48.5478 26.8382C48.5478 26.5024 48.5478 25.889 48.8562 25.5458C49.157 25.2172 49.6929 25.188 50.0598 25.188C50.4268 25.188 50.9627 25.2173 51.2636 25.5458C51.5717 25.889 51.5717 26.5024 51.5717 26.8382C51.5717 27.1522 51.5791 27.7363 51.2561 28.0868C50.948 28.4227 50.4561 28.4592 50.0597 28.4592C49.6633 28.4592 49.1717 28.4227 48.8633 28.0868C48.5406 27.7361 48.5478 27.152 48.5478 26.838V26.8382ZM52.9517 28.7586H54.0527C54.6839 28.7586 55.1243 28.6417 55.4326 28.1817C55.7116 27.7582 55.7409 27.2544 55.7409 26.7652C55.7409 26.3053 55.7262 25.7503 55.3299 25.3341C54.9482 24.9252 54.4271 24.8887 54.1702 24.8887H53.1865C53.0765 24.8887 52.9003 24.896 52.7535 25.0055C52.6963 25.0478 52.6498 25.1028 52.618 25.1662C52.5861 25.2297 52.5697 25.2997 52.57 25.3706V29.9998H52.9516L52.9517 28.7586ZM52.9517 28.4154V25.4216C52.9493 25.3955 52.9534 25.3692 52.9637 25.345C52.9739 25.3208 52.99 25.2995 53.0105 25.2829C53.0443 25.2557 53.0848 25.238 53.1279 25.2318H54.2509C54.6032 25.2318 55.0069 25.3851 55.1904 25.794C55.2784 25.9911 55.3298 26.2833 55.3298 26.8162C55.3298 27.3201 55.2858 27.707 55.1097 27.9772C54.9117 28.2765 54.5592 28.4154 54.207 28.4154H52.9517ZM56.4748 24.8886V25.2318H58.3612C58.4383 25.2301 58.5149 25.2448 58.5858 25.275C58.6567 25.3052 58.7203 25.3503 58.7723 25.407C58.8677 25.5238 58.9191 25.7429 58.9191 25.867V26.4438H57.2308C57.0107 26.4438 56.7169 26.473 56.5041 26.6482C56.2252 26.8819 56.1812 27.247 56.1812 27.5609C56.1812 27.7946 56.2032 28.3203 56.5261 28.5831C56.739 28.7511 57.0106 28.7583 57.2308 28.7583H58.7281C58.8601 28.7583 59.0511 28.7583 59.1686 28.6488C59.2933 28.532 59.3006 28.3495 59.3006 28.2472V25.9326C59.3006 25.699 59.2712 25.3777 59.0657 25.1587C58.9117 24.9907 58.6473 24.8885 58.3831 24.8885L56.4748 24.8886ZM58.919 26.7871V28.2401C58.919 28.2913 58.919 28.3277 58.8676 28.3715C58.8162 28.4153 58.7428 28.4153 58.6988 28.4153H57.1281C57.0561 28.416 56.9848 28.4013 56.919 28.3723C56.8531 28.3434 56.7943 28.3007 56.7464 28.2473C56.6143 28.0866 56.5923 27.8092 56.5923 27.5756C56.5923 27.3054 56.6217 27.101 56.7171 26.9768C56.7758 26.8965 56.9151 26.787 57.1428 26.787L58.919 26.7871ZM63.1319 28.7586V24.8887H62.7504V26.5901H60.4164V24.8887H60.0347V28.7586H60.4164V26.9331H62.7504V28.7585L63.1319 28.7586Z" fill="#131313"/>
                  </svg>                                      
                </div>
              </Link>
              <form method="dialog">
                  <button className={localStyle["text"]} onClick={e => setShowingMobileMenu(false)}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fillRule="evenodd" clipRule="evenodd" d="M1.70711 0.706956C1.31658 0.316431 0.683417 0.316431 0.292893 0.706956C-0.0976311 1.09748 -0.0976311 1.73064 0.292893 2.12117L10.1925 12.0208L0.293044 21.9202C-0.09748 22.3107 -0.09748 22.9439 0.293044 23.3344C0.683569 23.7249 1.31673 23.7249 1.70726 23.3344L11.6067 13.435L21.5061 23.3344C21.8966 23.7249 22.5298 23.7249 22.9203 23.3344C23.3108 22.9438 23.3108 22.3107 22.9203 21.9202L13.0209 12.0208L22.9205 2.12119C23.311 1.73067 23.311 1.0975 22.9205 0.706981C22.5299 0.316456 21.8968 0.316456 21.5062 0.706981L11.6067 10.6065L1.70711 0.706956Z" fill="#131313"/>
                      </svg>
                  </button>
              </form>
          </div>
          <nav>
              <ul>
                  <NavLink to="/menu"
                    className={({ isActive }) => isActive ? localStyle['active'] : ''}
                    onClick={onMobileNav}
                  ><li>Меню</li></NavLink>
                  <NavLink to="/reservation"
                    className={({ isActive }) => isActive ? localStyle['active'] : ''}
                    onClick={onMobileNav}
                  ><li>Бронирование</li></NavLink>
                  <NavLink to="/events"
                    className={({ isActive }) => isActive ? localStyle['active'] : ''}
                    onClick={onMobileNav}
                  ><li>События</li></NavLink>
                  <NavLink to="/job"
                    className={({ isActive }) => isActive ? localStyle['active'] : ''}
                    onClick={onMobileNav}
                  ><li><img className={localStyle['careers-button']} src={CareersButton} alt="Карьера" /></li></NavLink>
                  <NavLink to="/partner"
                    className={({ isActive }) => isActive ? localStyle['active'] : ''}
                    onClick={onMobileNav}
                  ><li>Франчайзи</li></NavLink>
                  <NavLink to="/contacts"
                    className={({ isActive }) => isActive ? localStyle['active'] : ''}
                    onClick={e => {
                      scrollToFooter(e, width)
                      hideMobileMenu(e)
                    }}
                  ><li>Контакты</li></NavLink>
              </ul>
          </nav>
          <a href={`tel:${places?.[current]?.phone}`}><div className={localStyle["phone"]}>{places?.[current]?.phone || 'тлф. неизвестен'}</div></a>
          <div className={localStyle["socials"]}>
              {/** instagram */}
              <svg
                onClick={e => window.open(places?.[current]?.city__instagram, "_blank").focus()}
                className={localStyle["social"]} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="30" height="30" rx="15" fill="#41B64D"/>
                  <path d="M15 8.85542C16.988 8.85542 17.259 8.85542 18.0723 8.85542C18.7952 8.85542 19.1566 9.03614 19.4277 9.12651C19.7892 9.30723 20.0602 9.39759 20.3313 9.66868C20.6024 9.93976 20.7831 10.2108 20.8735 10.5723C20.9639 10.8434 21.0542 11.2048 21.1446 11.9277C21.1446 12.741 21.1446 12.9217 21.1446 15C21.1446 17.0783 21.1446 17.259 21.1446 18.0723C21.1446 18.7952 20.9639 19.1566 20.8735 19.4277C20.6928 19.7892 20.6024 20.0602 20.3313 20.3313C20.0602 20.6024 19.7892 20.7831 19.4277 20.8735C19.1566 20.9639 18.7952 21.0542 18.0723 21.1446C17.259 21.1446 17.0783 21.1446 15 21.1446C12.9217 21.1446 12.741 21.1446 11.9277 21.1446C11.2048 21.1446 10.8434 20.9639 10.5723 20.8735C10.2108 20.6928 9.93976 20.6024 9.66868 20.3313C9.39759 20.0602 9.21687 19.7892 9.12651 19.4277C9.03614 19.1566 8.94578 18.7952 8.85542 18.0723C8.85542 17.259 8.85542 17.0783 8.85542 15C8.85542 12.9217 8.85542 12.741 8.85542 11.9277C8.85542 11.2048 9.03614 10.8434 9.12651 10.5723C9.30723 10.2108 9.39759 9.93976 9.66868 9.66868C9.93976 9.39759 10.2108 9.21687 10.5723 9.12651C10.8434 9.03614 11.2048 8.94578 11.9277 8.85542C12.741 8.85542 13.012 8.85542 15 8.85542ZM15 7.5C12.9217 7.5 12.741 7.5 11.9277 7.5C11.1145 7.5 10.5723 7.68072 10.1205 7.86145C9.66868 8.04217 9.21687 8.31325 8.76506 8.76506C8.31325 9.21687 8.13253 9.57831 7.86145 10.1205C7.68072 10.5723 7.59036 11.1145 7.5 11.9277C7.5 12.741 7.5 13.012 7.5 15C7.5 17.0783 7.5 17.259 7.5 18.0723C7.5 18.8855 7.68072 19.4277 7.86145 19.8795C8.04217 20.3313 8.31325 20.7831 8.76506 21.2349C9.21687 21.6867 9.57831 21.8675 10.1205 22.1386C10.5723 22.3193 11.1145 22.4096 11.9277 22.5C12.741 22.5 13.012 22.5 15 22.5C16.988 22.5 17.259 22.5 18.0723 22.5C18.8855 22.5 19.4277 22.3193 19.8795 22.1386C20.3313 21.9578 20.7831 21.6867 21.2349 21.2349C21.6867 20.7831 21.8675 20.4217 22.1386 19.8795C22.3193 19.4277 22.4096 18.8855 22.5 18.0723C22.5 17.259 22.5 16.988 22.5 15C22.5 13.012 22.5 12.741 22.5 11.9277C22.5 11.1145 22.3193 10.5723 22.1386 10.1205C21.9578 9.66868 21.6867 9.21687 21.2349 8.76506C20.7831 8.31325 20.4217 8.13253 19.8795 7.86145C19.4277 7.68072 18.8855 7.59036 18.0723 7.5C17.259 7.5 17.0783 7.5 15 7.5Z" fill="white"/>
                  <path d="M15 11.1145C12.8313 11.1145 11.1145 12.8313 11.1145 15C11.1145 17.1687 12.8313 18.8855 15 18.8855C17.1687 18.8855 18.8855 17.1687 18.8855 15C18.8855 12.8313 17.1687 11.1145 15 11.1145ZM15 17.5301C13.6446 17.5301 12.4699 16.4458 12.4699 15C12.4699 13.6446 13.5542 12.4699 15 12.4699C16.3554 12.4699 17.5301 13.5542 17.5301 15C17.5301 16.3554 16.3554 17.5301 15 17.5301Z" fill="white"/>
                  <path d="M18.9759 11.9277C19.475 11.9277 19.8795 11.5231 19.8795 11.0241C19.8795 10.525 19.475 10.1205 18.9759 10.1205C18.4769 10.1205 18.0723 10.525 18.0723 11.0241C18.0723 11.5231 18.4769 11.9277 18.9759 11.9277Z" fill="white"/>
              </svg>
              <svg
                onClick={e => window.open(places?.[current]?.city__vk, "_blank").focus()}
                className={localStyle["social"]} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="30" height="30" rx="15" fill="#41B64D"/>
                  <path d="M15.7369 20.25C10.0995 20.25 6.88398 16.3086 6.75 9.75H9.57386C9.66661 14.5638 11.7484 16.6029 13.3974 17.0233V9.75H16.0564V13.9017C17.6847 13.723 19.3955 11.8311 19.9727 9.75H22.6316C22.4142 10.8293 21.9806 11.8512 21.3582 12.7519C20.7358 13.6525 19.9378 14.4125 19.0142 14.9842C20.0452 15.5067 20.9557 16.2461 21.6859 17.1538C22.416 18.0615 22.9491 19.1168 23.25 20.25H20.3231C20.053 19.2657 19.504 18.3846 18.745 17.7171C17.986 17.0496 17.0507 16.6255 16.0564 16.4977V20.25H15.7369Z" fill="white"/>
              </svg>
          </div>
        </dialog>
      )
    }
  </>)
}

const Header = () => {
  return (
    <div className={localStyle['header']}>
      <HeaderInner type="header"/>
    </div>
  )
}

export default Header
